import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useLogin } from '~/components/Auth';
import { useMember } from '~/components/Member/Member.hooks';
import { UseSecurityOptions, useSecurity } from '~/components/Security';

export const useValidateMember = () =>
  useCallback(({ walletSignupUri }) => {
    if (walletSignupUri) {
      return 'UNAUTHORIZED_WALLET';
    }
  }, []);

export const useMemberErrorHandler = () => {
  const login = useLogin();

  return useCallback(
    async (error) => {
      switch (error.message) {
        case 'UNAUTHORIZED_WALLET': {
          login();
          break;
        }
      }
    },
    [login]
  );
};
export const useMemberSecurity = (
  options?: Optional<UseSecurityOptions, 'values' | 'validate'>
) => {
  const { data } = useMember();
  const validate = useValidateMember();
  const onError = useMemberErrorHandler();

  return useSecurity({
    values: [data],
    validate: () => validate(data),
    useErrorBoundary: false,
    onError,
    ...options,
  });
};

export const useGuestSecurity = (options?: Optional<UseSecurityOptions, 'values' | 'validate'>) => {
  const history = useHistory();
  const {
    data: { isLoggedIn },
  } = useMember();
  const onError = useCallback(
    async (error) => {
      switch (error.message) {
        case 'NOT_GUEST': {
          history.replace('/');
          break;
        }
      }
    },
    [history]
  );

  return useSecurity({
    values: [isLoggedIn],
    validate: () => {
      if (isLoggedIn) {
        return 'NOT_GUEST';
      }
    },
    useErrorBoundary: false,
    onError,
    ...options,
  });
};
